import { AddCircle, PersonAdd } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { createContext, useState } from 'react'
import { ModalAgregarUsuarioComponent } from '../../components/usuarios/ModalAgregarUsuarioComponent';
import { TablaUsuariosComponent } from '../../components/usuarios/TablaUsuariosComponent'
import { ObtenerUsuarios } from '../../helpers/UsuariosHelper';


export const UsuariosContext = createContext();

export const UsuariosPage = () => {
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState();
    const [modalAgregaUsuario, setModalAgregaUsuario] = useState();
    const [usuarios, setUsuarios] = useState([]);

    const obtenerUsuarios = async() => {
        const respuesta = await ObtenerUsuarios().then(datos=>setUsuarios(datos));
        console.log('datos obtenidos',respuesta);
    }

  return (
    <UsuariosContext.Provider value={{usuarioSeleccionado, setUsuarioSeleccionado,
        modalAgregaUsuario, setModalAgregaUsuario, obtenerUsuarios, usuarios, setUsuarios,
    }}>
    <div
    style={{
        display:'flex',
        flexDirection:'column',
        flex:1,
          color:'black',
          marginTop:10,
          marginLeft:40,
          marginRight:20,
      }}    
    >
    <div
        style={{
          display:'flex',
          flexDirection:'row',
          justifyContent:'space-between',
          //maxWidth:700
        }}
      >
        <span
            style={{
              fontSize:40,
              fontWeight:'bold'
            }}
            >
            Usuarios
        </span>
        <span
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
          }}
        >
          <IconButton
            onClick={() => {setUsuarioSeleccionado(); setModalAgregaUsuario(true)}}
          >
            <PersonAdd style={{color:'#60318A'}} color="#60318A" />
            Agregar
          </IconButton>
        </span>
      </div>
      <div>
          <TablaUsuariosComponent />
      </div>
      <ModalAgregarUsuarioComponent  />
    </div>
    </UsuariosContext.Provider>
  )
}
